import { HttpClient } from '@angular/common/http';
import { Giorno, Settimana, WID } from 'app/model/time';
import { flatMap, map, publishLast, refCount, take } from 'rxjs/operators';
import { RESTArray } from '../angular-rest';


export class Alternativa extends RESTArray<Settimana, WID> {

	constructor($http: HttpClient, uri: string) {
		super(
			$http,
			uri,
			(h, u, c) => Object.assign(Array.range(7)
				.map(id =>
					new Giorno($http, `${uri}/${c.settimana}/${id}`)
				), {
					settimana: c.settimana,
					tag: c.tag
				})  as Settimana,
			({ settimana }) => ({ id: settimana })
		);
	}

	// FIXME: da rivedere una volta finita la add di RESTArray
	put(da: string, a: string, tag?: string): Promise<Settimana[]> {
		const obs = this.pipe(
			take(1),
			flatMap(arr => {
				const newArr = arr.slice();
				return this.$http
					.put<WID>(this.uri, { da, a, tag })
					.pipe(
						map(res => {
							newArr.push(this.type(
								this.$http,
								`${this.uri}/${this.getUri(this.getID(res))}`,
								res
							));
							return newArr;
						})
					);
			}),
			publishLast(),
			refCount()
		);

		// Aggiungo la richiesta alla pipeline!
		this.generator.next(obs);

		// Questa sottoscrizione mi assicura che la chiamata non venga cancellata
		// per via di un unsubscribe lato switch
		return obs.toPromise();
	}
}



// WEBPACK FOOTER //
// ./src/app/model/alternativa.ts